import { getRuleErrorMessage, URLRegex } from "@/utils/formHelper";
import { QRMp3Form } from "@/data/types/qrForms";
import { FormValidationMethods } from "@/components/Form/types";
import { qrListPickerValidations, qrNameValidation } from "./shared";
import { TFunction } from "i18next";

export const mp3Validation = (data: QRMp3Form, methods: FormValidationMethods, t: TFunction) => {
  return [
    qrNameValidation(t),
    {
      name: "mp3Title",
      rules: {
        maxLength: {
          value: 100,
          message: getRuleErrorMessage("mp3Title", "maxLength", data),
        },
      },
    },
    {
      name: "mp3Description",
      rules: {
        maxLength: {
          value: 200,
          message: getRuleErrorMessage("mp3Description", "maxLength", data),
        },
      },
    },
    {
      name: "mp3ButtonText",
      rules: {
        maxLength: {
          value: 50,
          message: getRuleErrorMessage("mp3ButtonText", "maxLength", data),
        },
        validate: {
          mp3ButtonTextRequired: (value: string) => {
            const isValid = true;
            if (methods?.getValues("mp3ButtonUrl")?.length > 0 && value?.length === 0) {
              return getRuleErrorMessage("mp3ButtonText", "validate", data);
            }
            return isValid;
          },
        },
      },
    },
    {
      name: "mp3ButtonUrl",
      rules: {
        pattern: {
          value: new RegExp(URLRegex),
          message: getRuleErrorMessage("mp3ButtonUrl", "pattern", data),
        },
        validate: {
          mp3ButtonUrlRequired: (value: string) => {
            const isValid = true;
            if (methods?.getValues("mp3ButtonText")?.length > 0 && value?.length === 0) {
              return getRuleErrorMessage("mp3ButtonUrl", "validate", data);
            }
            return isValid;
          },
        },
      },
    },
    ...qrListPickerValidations("social_invalid", t),
  ];
};
